const style = {
    centerContainer: {
        width: {
            xs: '90%',
            md: '60%',
        },

        margin: 'auto',
    },

    blogTitle: {
        fontFamily: 'bold',
        fontSize: '35px',
        color: '#333',
    },

    blogDate: {
        fontFamily: 'poppins',
        fontSize: '13px',
        color: '#2e8359',
    },

    contentContainer: {
        margin: '20px 0px 0px 0px' ,
    },

    contentText: {
        fontFamily: 'poppins',
        fontSize: '13px',
        color: '#333',
    },
}
export default style;